<template>
    <div class="fondovista">    
        <div class="container">
            <transition name="slide-fade" appear>
                <b-card>
                    <div class="mt-2"><strong>REVISIÓN DE TAREAS</strong> | Docente: <strong><em>{{ datosSesion.nombres }} {{ datosSesion.apellidos }}</em></strong></div>
                    <hr>
                    <b-row>
                        <b-col md="5">
                            <b-form-group class="small" label="Lista de Aulas:" label-for="aulas">
                                <b-form-select size="sm" id="aulas" v-model="idAsignaturaDocente" :options="listaComboAsignaturasDocente" @change="cargaActividades()">
                                    <template slot="first"><option :value="null" disabled>-- Seleccione un Aula --</option></template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="7">
                            <b-form-group class="small" label="Lista de Actividades:" label-for="actividades">
                                <b-form-select size="sm" id="actividades" v-model="idActividad" :options="listaComboActividades" @change="cargaTareasActividad()">
                                    <template slot="first"><option :value="null" disabled>-- Seleccione una Actividad --</option></template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <vue-good-table
                                :columns="titulos"
                                :line-numbers="true"
                                :search-options="{
                                    enabled: true,
                                    placeholder: 'Buscar...'
                                }"
                                :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    nextLabel: 'Siguiente',
                                    prevLabel: 'Anterior',
                                    rowsPerPageLabel: 'Filas por página',
                                    ofLabel: 'de',
                                    pageLabel: 'página',
                                    allLabel: 'Todo'
                                }"
                                styleClass="vgt-table bordered condensed striped sm"
                                :rows="listaEstudiantesAulaTareas"
                                >
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field === 'tarea'">
                                        <a href="#" @click="revisarTareaEstudiante(props.row)">{{ props.row.tarea }}</a>
                                    </span>
                                </template>
                            </vue-good-table>
                        </b-col>
                    </b-row>
                </b-card>
            </transition>
        </div>
        <b-modal scrollable size="xl" title="Revisar Tarea" header-bg-variant="success" header-text-variant="light" v-model="verModalTarea">
            <b-card-text>
            <div class="mt-2">Actividad: <strong><em>{{ this.tituloActividad }}</em></strong></div>
            <div class="mt-2">Estudiante: <strong><em>{{ this.estudianteTarea }}</em></strong></div>
            <hr>
                <form>
                    <div class="container">
                        <b-row>
                            <b-col lg="12">
                                <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" disabled></ckeditor>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="mt-3">
                                <label>Observaciones:</label>
                                <b-form-textarea v-model="observacionesTarea" id="textarea-rows" placeholder="Observaciones" rows="3"></b-form-textarea>
                            </b-col>
                        </b-row>
                    </div>
                </form>
            </b-card-text>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button size="sm" variant="success" @click="tareaRevisada"> Dar por Revisada la Tarea</b-button>
                <b-button size="sm" variant="" @click="cancel()"> Cancelar </b-button>
            </template>
        </b-modal>


    </div>
</template>

<script>
    import axios from "axios"
    import * as CONFIG from '@/assets/config.js'
    import {mapState} from 'vuex'
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    export default {
        name: 'RevisarTareas',
        components: {
        },
        data() {
            return {
                asignaturasDocente: [],
                listaComboAsignaturasDocente: [],
                idAsignaturaDocente: null,
                descripcionAsignaturasGrados: [],
                actividadesAula: [],
                listaComboActividades: [],
                idActividad: null,
                idCurso: '',
                listaEstudiantesAula: [],
                listaEstudiantesAulaTareas: [],
                titulos: [
                    { label: "Estudiante", field: "estudiante", sortable: false },
                    { label: "Documento", field: "documento", sortable: false },
                    { label: "Tarea", field: "tarea", sortable: false },
                    { label: "Estado Tarea", field: "revisada", sortable: false, formatFn: this.textoEstadoTarea, tdClass: this.claseEstadoTarea }
                ],
                tareasActividad: [],
                tituloActividad: '',
                estudianteTarea: '',
                verModalTarea: false,
                editor: ClassicEditor,
                editorData: '',
                editorConfig: {},
                observacionesTarea: ''
            }
        },
        methods: {
            async tareaRevisada() {
                let datosTareaRevisada = {}
                datosTareaRevisada.observaciones = this.observacionesTarea
                datosTareaRevisada.revisada = 1
                await axios
                .put(CONFIG.ROOT_PATH + "tareas/revisada/" + this.idTarea, JSON.stringify(datosTareaRevisada),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
                    .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.mensajeEmergente("success","Mensaje",response.data.mensaje)
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
                this.cargaTareasActividad()
                this.verModalTarea = false
            },
            revisarTareaEstudiante(estudianteSeleccionado) {
                this.tituloActividad = document.getElementById("actividades").options[document.getElementById("actividades").selectedIndex].text;
                this.idTarea = estudianteSeleccionado.id_tarea
                this.estudianteTarea = estudianteSeleccionado.estudiante
                this.observacionesTarea = estudianteSeleccionado.observaciones
                this.editorData = estudianteSeleccionado.contenido
                this.verModalTarea = true
            },
            async cargaTareasActividad() {
                this.listaEstudiantesAulaTareas = []
                await axios
                .get(CONFIG.ROOT_PATH + "aula/tareas/actividad/" + this.idActividad)
                    .then(response => {
                    if (response.data.datos) {
                        // Campos: 
                        this.tareasActividad = response.data.datos
                    } else {
                        this.tareasActividad = []
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
                for (let j = 0; j < this.listaEstudiantesAula.length; j++) {
                    this.listaEstudiantesAula[j].id_tarea = ''
                    this.listaEstudiantesAula[j].contenido = ''
                    this.listaEstudiantesAula[j].fecha_tarea = ''
                    this.listaEstudiantesAula[j].observaciones = ''
                    this.listaEstudiantesAula[j].revisada = ''
                    this.listaEstudiantesAula[j].tarea = ''
                }
                for (let i = 0; i < this.tareasActividad.length; i++) {
                    for (let j = 0; j < this.listaEstudiantesAula.length; j++) {
                        if (this.tareasActividad[i].id_matricula == this.listaEstudiantesAula[j].id_matricula && this.tareasActividad[i].id_actividad == this.idActividad) {
                            this.listaEstudiantesAula[j].id_tarea = this.tareasActividad[i].id
                            this.listaEstudiantesAula[j].contenido = this.tareasActividad[i].contenido
                            this.listaEstudiantesAula[j].fecha_tarea = this.tareasActividad[i].fecha_tarea
                            this.listaEstudiantesAula[j].observaciones = this.tareasActividad[i].observaciones
                            this.listaEstudiantesAula[j].revisada = this.tareasActividad[i].revisada
                            this.listaEstudiantesAula[j].tarea = 'Ver Tarea'
                        }
                    }
                }
                this.listaEstudiantesAulaTareas = this.listaEstudiantesAula
            },
            async cargaActividades() {
                await axios
                .get(CONFIG.ROOT_PATH + "actividades/aula/" + this.idAsignaturaDocente)
                    .then(response => {
                    if (response.data.error){
                        this.listaComboActividades = []
                        this.idActividad = null
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.actividadesAula = response.data.datos
                        this.listaComboActividades = []
                        this.idActividad = null
                        this.actividadesAula.forEach(element => {
                            this.listaComboActividades.push({value: element.id, text: element.titulo})
                        });
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
                this.listaEstudiantesAulaTareas = []
                this.cargaEstudiantesAula()        
            },
            async cargaEstudiantesAula() {
                this.idCurso = ''
                this.asignaturasDocente.forEach(element => {
                    if (element.id_asignatura_docente == this.idAsignaturaDocente) {
                        this.idCurso = element.id_curso
                    }
                });
                await axios
                .get(CONFIG.ROOT_PATH + "estudiantes/aula/" + this.idCurso)
                    .then(response => {
                    if (response.data.error){
                        this.listaEstudiantesAula = []
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        // Campos: id_estudiante, estudiante, documento, id_matricula
                        this.listaEstudiantesAula = response.data.datos
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
            },
            async cargarAsignaturasDocente() {
                await axios
                .get(CONFIG.ROOT_PATH + "asignaturas/docente/" + this.datosSesion.idUsuario)
                    .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.asignaturasDocente = response.data.datos
                        for (let i = 0; i < this.asignaturasDocente.length; i++) {
                            for (let j = 0; j < this.descripcionAsignaturasGrados.length; j++) {
                                if (this.asignaturasDocente[i].id_asignatura_grado == this.descripcionAsignaturasGrados[j].id_asignatura_grado) {
                                    this.listaComboAsignaturasDocente.push({value: this.asignaturasDocente[i].id_asignatura_docente, text: this.asignaturasDocente[i].nomenclatura + ' | ' + this.descripcionAsignaturasGrados[j].descripcion})
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })                
            },
            async cargarDescripcionAsignaturasGrados() {
                await axios
                .get(CONFIG.ROOT_PATH + "asignaturas/descripcionasignaturasgrados")
                    .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.descripcionAsignaturasGrados = response.data.datos
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
            },
            textoEstadoTarea: function(value) {
                return (value == 0 ? 'Sin Revisar' : 'Revisada')
            },
            claseEstadoTarea(row) {
                return (row.revisada == 0 ? 'text-danger' : 'text-success')
            },
            mensajeEmergente(variante, titulo, contenido) {
                this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false });
            }
        },
        beforeMount() {
            this.cargarDescripcionAsignaturasGrados()
            this.cargarAsignaturasDocente()
        },
        computed: {
            ...mapState(['datosSesion'])
        }
    }
</script>